const zh = {
	title: '成员标准库',
	searchPlaceholder: '请输入姓名',
	allTeams: '全部团队',
	allMajors: '全部专业',
	memberList: '成员列表',
	waitingToAddMembers: '待添加的成员',
	synchronization: '同步',
	noMember: '暂无成员',
	addMember: '添加成员',
	avatar: '头像',
	englishName: '英文名',
	chineseName: '中文名',
	cellPhoneNumber: '手机号',
	mailbox: '邮箱',
	major: '专业',
	team: '团队',
	cancel: '取消',
	confirm: '确定',
	search: '搜索',
	add: '添加',
	back: '返回',
	addIbraryMember: '添加标准库成员',
};

export default zh;
